export const isInLastRow = (index: number, numOfItems: number, columns = 2) => {
  const startIndexLastRow = numOfItems - (numOfItems % columns || columns);
  return index >= startIndexLastRow;
};
